import React from "react";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import { useFinalisation } from "src/pages/finalisation/FinalisationContext";
import AppCol from "src/commun/composants/grille/AppCol";
import AppRow from "src/commun/composants/grille/AppRow";
import { useAppText } from "src/commun/composants/AppText";
import CodeMailSendForm from "src/pages/finalisation/etapes/verificationMail/codeMailSend/CodeMailSendForm";
import { useAppState } from "src/app/state/StateProvider";
import { sendCodeMail } from "src/app/api/PublicApi";

export type VerificationMailContainerProps = {
  initialValues: VerificationMail;
  stepSuivante: () => void
};

const CodeMailSendFormContainer = ({ initialValues, stepSuivante }: VerificationMailContainerProps) => {
  const { tString } = useAppText();
  const [{ langue }] = useAppState();
  const [{ configuration }] = useAppState();
  const [value, api] = useFinalisation();

  const submitSuccessHandler = (result: GenericApiResponse<any>, values: FormikValues) => {
    const etapes = [...value.etapes];
    etapes[0].data = values;
    api.setEtapes(etapes);
    stepSuivante();
  };

  const submitFormAPI = (values: FormikValues) => sendCodeMail(values as VerificationMail, langue);

  return (
    <>
      <AppRow>
        <AppCol md={7}>
          <label>{tString("compte.saisie.email.message", [configuration?.codeDelaiValidite])}</label>
        </AppCol>
        <AppCol md={5}>
          <CodeMailSendForm
            initialValues={initialValues}
            submitSuccessHandler={submitSuccessHandler}
            submitFormAPI={submitFormAPI}
            allowRattachement={true}
            userToFinalize={value.userToFinalize}
          />
        </AppCol>
      </AppRow>
    </>
  );
};

export default CodeMailSendFormContainer;